import createBaseService from "@/api/base-service.ts";
import type { CourtTypeStation } from "../../types/court-type-station";

const courtTypeStationService = {
	...createBaseService<CourtTypeStation>("/court-type-stations"),
};

export default courtTypeStationService;
